import React from "react";
import styles from "./FloMultipleSlider.module.css";
import Slider from "rc-slider";
import {
  Slider as MultipleSlider,
  Rail,
  Handles,
  Tracks,
} from "react-compound-slider";
import { Handle, Track } from "./components";
import classnames from "classnames";
import "rc-slider/assets/index.css";
import { FloComponentProps } from "components";

interface FloMultipleSliderProps extends FloComponentProps {
  min: number;
  max: number;
  step: number;
  minValue: number;
  maxValue: number;
  rightSymbol: string;
  leftSymbol: string;
  disabled: boolean;
  onChange: (value: number) => void;
  onMultipleChange: (values: readonly number[]) => void;
}

const sliderStyle: React.CSSProperties = {
  margin: "5%",
  position: "relative",
  width: "90%",
};

const railStyle: React.CSSProperties = {
  position: "absolute",
  width: "100%",
  height: 4,
  borderRadius: 7,
  cursor: "pointer",
  backgroundColor: "#CED3DC",
};

export const FloMultipleSlider: React.FC<FloMultipleSliderProps> = React.memo(
  ({
    className,
    min,
    max,
    step,
    minValue,
    maxValue,
    leftSymbol,
    rightSymbol,
    disabled,
    onChange,
    onMultipleChange,
  }) => {
    if (maxValue > 0) {
      return (
        <div className={classnames(styles.root, className)}>
          <div className={styles.valueContainer}>
            <div className={styles.valueBox}>
              {minValue} {leftSymbol}
            </div>
          </div>
          <div className={styles.sliderContainer}>
            <MultipleSlider
              mode={2}
              domain={[min, max]}
              step={step}
              values={[minValue, maxValue]}
              rootStyle={sliderStyle}
              disabled={disabled}
              onChange={onMultipleChange}
            >
              <Rail>
                {({ getRailProps }) => (
                  <div style={railStyle} {...getRailProps()} />
                )}
              </Rail>
              <Handles>
                {({ handles, getHandleProps }) => (
                  <div className="slider-handles">
                    {handles.map((handle) => (
                      <Handle
                        key={handle.id}
                        handle={handle}
                        domain={[0, 1000]}
                        getHandleProps={getHandleProps}
                        isActive={true}
                      />
                    ))}
                  </div>
                )}
              </Handles>
              <Tracks left={false} right={false}>
                {({ tracks, getTrackProps }) => (
                  <div className="slider-tracks">
                    {tracks.map(({ id, source, target }) => (
                      <Track
                        key={id}
                        source={source}
                        target={target}
                        getTrackProps={getTrackProps}
                      />
                    ))}
                  </div>
                )}
              </Tracks>
            </MultipleSlider>
          </div>
          <div className={styles.valueContainer}>
            <div className={styles.valueBox}>
              {maxValue}
              {rightSymbol}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={classnames(styles.root, className)}>
          <div className={[styles.sliderContainer, styles.smallerContainer].join(' ')}>
            <div className={styles.valueContainer}></div>
            <Slider
              min={min}
              max={max}
              step={step}
              value={minValue}
              disabled={disabled}
              onChange={onChange}
            />
          </div>
          <div className={styles.valueContainer}>
            <div className={styles.lonelyValueBox}>
              {minValue}
              {rightSymbol}
            </div>
          </div>
        </div>
      );
    }
  }
);
